import * as React from 'react'

import { ContactDiv, PrincipalDiv } from './styles';

import LetreiroImg from '../../../../../assets/images/landingPage/letreiro.webp';
import { useEffect } from 'react';
import { jarallax } from 'jarallax';

interface IFooterProps {
  lp?: boolean;
}


const Letreiro: React.FC<IFooterProps> = ({ lp }) => {

  useEffect(() => {
  const elements = document.querySelectorAll('.jarallax');
  jarallax(elements, { speed: 0.4 });
  return () => jarallax(elements, 'destroy');
}, []);

  return (
    <PrincipalDiv className="jarallax" data-jarallax data-speed="0.3">
      
      <img className="jarallax-img" src={LetreiroImg} alt="" />

      <ContactDiv>
        <div className="marquee">
          <p className="marquee-text">
            BHBUS MÍDIA: TRANSFORME CADA TRAJETO EM OPORTUNIDADE DE MÍDIA
          </p>
        </div>
      </ContactDiv>

    </PrincipalDiv>
  );
};

export { Letreiro };